var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pv-trend-chart"},[_c('Chart',{ref:"bizChart",attrs:{"id":"pv-weekly-energy-chart","width":"100%","height":"100%","option":_vm.chartOption}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }